import { useQuery } from "hooks/useQuery";
import { useMutation } from "hooks/useMutation";
import { get, post } from "services/httpService";
import { CREATE_CASH_TRANSFER_URL } from "services";

/**
 * Hook to fetch account details and create cash transfers
 * @returns {Object} Object containing account details, loading states, and mutation functions
 */
export const useCreateCashTransfer = () => {
  // Fetch account details
  const {
    data: accountDetails,
    isLoading: isLoadingAccountDetails,
    refetch: refetchAccountDetails,
  } = useQuery({
    queryKey: ["accountDetails"],
    queryFn: async () => {
      const response = await get(CREATE_CASH_TRANSFER_URL);
      return response;
    },
  });

  // Create cash transfer mutation
  const { mutate: createCashTransfer, isLoading: isCreatingTransfer } =
    useMutation({
      mutationFn: async (payload) => {
        const response = await post(CREATE_CASH_TRANSFER_URL, payload);
        return response;
      },
      onSuccess: () => {
        // Refetch account details after successful transfer
        refetchAccountDetails();
      },
    });

  return {
    accountDetails,
    isLoadingAccountDetails,
    createCashTransfer,
    isCreatingTransfer,
    refetchAccountDetails,
  };
};
